import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ajaxPost, loginInfo, history, connection, getCookie } from '../../../global';
import queryString from 'query-string';

class EmailDirect extends Component {

  compareSession = () => {
    // var url = 'FB.CompareUserSession';
    // var data = {};//{session: getCookie("sessionID")};
    // data.session = getCookie("sessionID");
    // console.log("compare session Id : ", data)
    // ajaxPost(url, data).then(response => {
    //   console.log("compare session Id : ", response)
    //   if (response.Compare){
    //     //alert(response.Compare)
    //     // setTimeout(() => {
    //     //   history.push({
    //     //     pathname: "/login",
    //     //   })
    //     // }, 1000);
    //     if (window.TargetURL) {
    //       var params = window.TargetSearch ? queryString.parse(window.TargetSearch) : {};
    //       history.push({
    //         pathname: window.TargetURL,
    //         state: { ...params, needRefresh: true }
    //       })
    //     }
    //   }
    // })
    var url = 'FB.GetUserConfig';
    var UserID = getCookie("UserID");
    var language = getCookie("language");
    var data = { Code: UserID, language: language };
    data.session = getCookie("sessionID");
    console.log("getCookieData", data)
    ajaxPost(url, data).then(response => {

      // console.log(response);
      // console.log(loginInfo);
      if (response) {
        Object.assign(loginInfo, response);
        loginInfo.UserID = getCookie("UserID");
        loginInfo.Session = getCookie("sessionID");
        loginInfo.UserPreference = { Language: loginInfo.language, RefreshFrequency: 30 };
        
        loginInfo.save();
        loginInfo.startUpdateSession();

        console.log(loginInfo, "window", window, window.TargetURL, window.location.href);

        // if (loginInfo.UserType == "" && loginInfo.UserTypeList.length > 1)
        //   history.push('/menu');

        if (window.TargetURL) {
          console.log("window.TargetSearch ", window.TargetSearch);
          var params = window.TargetSearch ? queryString.parse(window.TargetSearch) : {};
          history.push({
            pathname: window.TargetURL,
            state: { ...params, needRefresh: true }
          })

        }
      }else{
        // return (<Redirec/t to='/login' />);
        history.push({
          pathname: "/login"
        })
      }
    })
  }

  componentDidMount() {
    console.log("Email Direct component", window)
    console.log("Email Direct component", window.TargetURL)
    this.compareSession();

    // if (window.TargetURL) {
    //   var params = window.TargetSearch ? queryString.parse(window.TargetSearch) : {};
    //   history.push({
    //     pathname: window.TargetURL,
    //     state: { ...params, needRefresh: true }
    //   })
    // }
  }

  render() {
    return (
      <div></div>
    );
  }
}
export default EmailDirect;


// WEBPACK FOOTER //
// ./src/views/Pages/EmailDirect/EmailDirect.js